<div class="facility-add-dialog" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" fxLayoutGap="15px">
    <app-address-form [addressForm]="addressForm" [title]="'Adres placówki'"></app-address-form>

    <mat-card>
      <div fxLayout="row">
        <h3>Uwagi</h3>
      </div>

      <div fxLayout="row">
        <mat-form-field fxFlex="100">
          <mat-label>Uwagi</mat-label>
          <textarea [formControl]="noteControl" matInput placeholder="Uwagi"></textarea>
        </mat-form-field>
      </div>
    </mat-card>

    <mat-card *ngIf="profitTag">
      <div fxLayout="row">
        <h3>Typ placówki</h3>
      </div>

      <div fxLayout="row" >
        <div fxFlex="100">
          <app-dict [label]="'Typ placówki'"
                    [dictType]="'facility_type' "
                    [control]="facilityTypeControl"
                    [required]="true"></app-dict>
        </div>
      </div>
    </mat-card>

    <mat-card *ngIf="profitPartner">
      <div fxLayout="row">
        <h3>Typ placówki</h3>
      </div>

      <div fxLayout="row" >
        <div fxFlex="100">
          <app-dict [label]="'Typ placówki'"
                    [onlyKeys]="PARTNER_TYPES"
                    [dictType]="'facility_type' "
                    [control]="facilityTypeControl"
                    [required]="true"></app-dict>
        </div>
      </div>
    </mat-card>


    <mat-card *ngIf="profitFacility">
      <div fxLayout="row">
        <h3>Profitowi</h3>
      </div>

      <app-dict-ofwcas label="Dyrektor struktury" [filterProfit]="true" [control]="structureDirectorControl" class="facility-dialog-partner" [required]="false"></app-dict-ofwcas>

      <app-dict-ofwcas label="Wicedyrektor" [filterProfit]="true" [control]="assistantDirectorControl" class="facility-dialog-partner" [required]="false"></app-dict-ofwcas>

      <app-dict-ofwcas label="Dyrektor reigonalny" [filterProfit]="true" [control]="regionalControl" class="facility-dialog-partner" [required]="false"></app-dict-ofwcas>
    </mat-card>

    <input type="hidden" [formControl]="partnerControl">
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="createFacility()" [class.spinner]="processingRequest"
            [disabled]="!addressForm.valid || !facilityTypeControl.valid"
            mat-stroked-button color="primary"><mat-icon>add</mat-icon> <span> Zapisz</span></button>

    <button (click)="closeDialog()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    <button  mat-stroked-button [matMenuTriggerFor]="copyMenu" color="accent"><mat-icon>content_copy</mat-icon> <span> Kopiuj adres</span></button>
    <mat-menu #copyMenu="matMenu">
      <button mat-menu-item (click)="copyHeadquartersAddress()">Siedziby</button>
      <button mat-menu-item (click)="copyCommunicationAddress()">Korespondencyjny</button>
    </mat-menu>
  </div>
</div>

